/**
 * External Dependencies, short list is needed on every page
 */

import "./components/nav";
import "./components/anim";
import "./components/accordion";
import "./components/modal";
import "./components/forms";
import "./components/preloader";
import "./components/carousel";
import "./components/filters";
import "./components/services";
import LazyLoad from "vanilla-lazyload";

// Lazyload images
let myLazyLoad = new LazyLoad();